// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54dccef0","453":"03c91911","732":"e342d956","977":"b84eb6e4"}[chunkId] + ".chunk.js";
};